module.exports = __webpack_public_path__ + "static/img/image-symbol.c0a10de1.png";